import { render, staticRenderFns } from "./URLInput.vue?vue&type=template&id=47e6b4c0&"
import script from "./URLInput.vue?vue&type=script&lang=js&"
export * from "./URLInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports